import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormGroupDirective } from '@angular/forms';
import { COUNTRIES } from 'src/app/account/auth/signup/countries';

@Component({
  selector: 'app-merchant-list-of-countries',
  templateUrl: './merchant-list-of-countries.component.html',
  styleUrls: ['./merchant-list-of-countries.component.scss']
})
export class MerchantListOfCountriesComponent implements OnInit {

    countries:any = []
    selected: string;
    form!: FormGroup
    @Input() userDetailsForm: FormGroup
    @Input() submitted: Boolean
    @Output() selectEvent = new EventEmitter<string>();
    @ViewChild('countryDropDown') selectTag;
    @Input() Send_Contry_Code: any;
    // @Input() Send_Contry_Code: string = '';
    Selected_Country: any;
    selectedCountry: any;
    constructor(private rootFormGroup: FormGroupDirective) {
      this.selected = '';
    }
    ngOnInit(): void {
      this.form = this.userDetailsForm
      this.countries = COUNTRIES

      this.selectedCountry = this.countries.filter((res)=>{
       return this.form.controls['country'].setValue(res.code)
      })
    }

    onOptionChange(country:any): void {
      this.selected = country;
      this.selectEvent.emit(this.selected);
    }


}
